import { useState, useCallback } from 'react'

const ERROR_MESSAGE = 'Please fill in all required fields'

export const useValidationForm = () => {
  const [errors, setErrors] = useState<string>('')

  const setHasErrors = useCallback(
    (isErrorsPresent: boolean): void => {
      if (isErrorsPresent) {
        setErrors(ERROR_MESSAGE)
      } else setErrors('')
    },
    [setErrors]
  )

  return {
    setHasErrors,
    errors,
  }
}
